import { FC, Fragment, useEffect, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { Form, Input, Row, Col, Card, Divider, Spin, notification } from "antd";
import "./hra-questionnaire.scss";
import memberDetailsService from "@services/memberDetails.service";
import { useNavigate } from "react-router-dom";
import { routeMap } from "@utils/constants";
import membersService from "@services/members.service";
import { useConfigStore } from "@stores/useConfigStore";
import Icon from "@assets/icon_config";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";

type LayoutType = Parameters<typeof Form>[0]["layout"];

const HRAQuestionnaire: FC<any> = () => {
  const [loadingForHra, setHraLoaderFlag] = useState(false);
  const [hraQuestionnarData, setHraQuestionnarData] = useState<any>([]);
  const [copyHraQuestionnarData, setCopyHraQuestionnarData] = useState<any>([]);
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>("vertical");
  const [editFlag, setEditFlag] = useState(false);
  const navigate  = useNavigate();

  // const [updateQuestions, setUpdateQuestions] = useState([]);
  const [pID, setPID] = useState(Number)
  const [showLoader, setShowLoader] = useState(false);
  const config: any = useConfigStore(state => state.config)

  useEffect(() => {
    console.log("HRAQuestionnaire.useEffect1");
    appInsights.trackPageView({name:"HRA Questionnaire"});
  },[]);

   useEffect(() => {
    console.log("HRAQuestionnaire.useEffect2");
    const cMember = membersService?.getCurrentMember;
    if(cMember && cMember?.patient_id)
    {
      let pId = parseInt(cMember?.patient_id);
      setPID(pId);
      getHraQuestionnaries(pId);
    }
    else 
     navigate(routeMap["members"])
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [membersService?.getCurrentMember?.patient_id]);

  const onFinish = (values: any) => {
    console.log("Success:", values);
    // console.log("arr:", updateQuestions);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
    // console.log("arr:", updateQuestions);
  };

  const onAnswerChange = (e:any, obj:any)=> {
    let old: any = {...obj , answerDescription : e.target.value};
    // let oldArr:any = [...updateQuestions]
    // let found = oldArr.filter((oa:any) => oa.questionId === old.questionId)
    // if(found && found.length > 0 ){
    //   const temp = oldArr.map((oa:any)=>{
    //     if(oa.questionId === old.questionId){
    //         oa.answerDescription = old.answerDescription;
    //     }
    //     return oa;
    //   })
    //   setUpdateQuestions(temp);
    // }
    // else
    // {
    //   oldArr.push(old)
    //   setUpdateQuestions(oldArr)
    // }
    let tempHRAData = hraQuestionnarData.map((qa:any)=>{
      let localQA : any = qa;
      if(qa.questionId === old.questionId){
        localQA = {...localQA , answerDescription : old.answerDescription}
      }
      return localQA;
    })
    setHraQuestionnarData(tempHRAData);
  }

  const onUpdateQuestions = () => {
    if(hraQuestionnarData.filter((a:any)=>a.answerDescription===null || a.answerDescription===undefined || a.answerDescription.trim() === "").length>0){
      notification.error({
        message: "Error",
        description: "Field should not be empty.",
      });
    }else {
      setShowLoader(true);
      let copyUpdateQuestions = [...hraQuestionnarData]
      memberDetailsService.submitAnswers(pID, copyUpdateQuestions).subscribe({
        next: (v) => {
          setShowLoader(false);
          setEditFlag(false);
          setCopyHraQuestionnarData(hraQuestionnarData);
        },
        error: (e) => {
          setShowLoader(false);
        },
      });
    }
  }

  const getHraQuestionnaries = (id: number) => {
    console.log("HRAQuestionnaire.getHraQuestionnaries");
    setHraLoaderFlag(true);
    memberDetailsService.getQuestionList(id).subscribe({
      next: (v) => {
        console.log(v);
        setHraLoaderFlag(false);
        setHraQuestionnarData(v.data.data.item);
        setCopyHraQuestionnarData(v.data.data.item);
      },
      error: (e) => {
        console.log(e);
        setHraLoaderFlag(false);
        setHraQuestionnarData([])

      },
    });
  };

  return (
    <Spin spinning={loadingForHra} indicator={<HealthemSpinner size={70}/>}>
    <Card>
      <Form
        layout={formLayout}
        form={form}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Row className="questionnaire-header">
          <Col span={12} className="clr-n100">
            <span>Questionnaire</span>
          </Col>
          
          <Col span={12} style={{ textAlign: "right" }}>
            <CanEdit>
            {editFlag ? (
              <>
              <Spin spinning={showLoader} indicator={<HealthemSpinner/>}>
                <span
                  style={{ margin: "0 20px" }}
                  className="link clr-n125  hra-edit-alignment"
                  onClick={() => {
                    form.resetFields();
                    setEditFlag(false);
                    setHraQuestionnarData(copyHraQuestionnarData);
                  }}
                >
                  Cancel
                </span>
                <span className="link hra-edit-alignment" onClick={onUpdateQuestions}>
                  Save Changes
                </span>
                </Spin>
              </>
              
            ) : (
              <>
              {!editFlag && config.member_detail["HRA Questionnaire"].enabled && <span
                  className="link clr-blueLink hra-edit-alignment"
                  onClick={() => setEditFlag(true)}
                >
                  <i
                    style={{ verticalAlign: "middle", marginRight: 10 }}
                    className="icon icon-edit"
                  ></i>
                  Edit
                </span>}
                
              </>
            )}
            </CanEdit>
          </Col>
        </Row>
        {hraQuestionnarData?.map((obj: any, idx: number) => (
          <Fragment key={idx}>
            <div className = "hraQuestionnarData" key={idx}>
              <div className="f16 clr-n125" style={{ marginRight: 20 }}>
                {obj.questionId}.
              </div>
              <Form.Item
                style={{ marginBottom: 0 }}
                className="f16 clr-n125"
                label={obj?.questionDescription}
                name={obj.questionId}
                rules={[{ required: true, message: <span><span className="hrainfo"><Icon name="hrainfo"/></span>Field should not be empty</span> }]}
              >
                {editFlag ? (
                  <Input
                    style={{
                      width: "320px",
                      height: "40px",
                      borderRadius: "4px",
                    }}
                    defaultValue={obj?.answerDescription}
                    // onChange={(e)=>onAnswerChange(e, obj)}
                    onBlur={(e)=>onAnswerChange(e, obj)}
                    />
                ) : (
                  <span className="f16 w500 clr-n100">
                    {obj?.answerDescription}
                  </span>
                )}
              </Form.Item>
            </div>
            <Divider plain type="horizontal" className="clr-n125"></Divider>
          </Fragment>
        ))}
      </Form>
    </Card>
    </Spin>
  );
};

export default withAITracking(reactPlugin, HRAQuestionnaire);
